module.exports = __webpack_public_path__ + "static/our-growth-87d45020dc4830fcc97def2693b0c423.png";